import type { OnChangeFn, SortingState } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC, RefObject } from "react"
import type { CombinedError } from "urql"

import { usePriceApprovalColumns } from "../hooks/usePriceApprovalColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { PriceChangeSubmission } from "@/graphql/codegen/graphql"

interface PriceApprovalTableProps {
  data: PriceChangeSubmission[]
  loading?: boolean
  error?: CombinedError | Error
  sorting: SortingState
  containerRef?: RefObject<HTMLDivElement>
  onSortingChange: OnChangeFn<SortingState>
  onScroll?: () => void
}

export const PriceApprovalTable: FC<PriceApprovalTableProps> = ({
  data,
  error,
  loading = false,
  sorting,
  containerRef,
  onSortingChange,
  onScroll,
}) => {
  const columns = usePriceApprovalColumns()

  return (
    <AerosBaseTable
      error={error}
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data,
          columns,
          state: {
            sorting,
            isLoading: loading,
          },
          manualSorting: true,
          enableSorting: true,
          enableMultiSort: false,
          enableSortingRemoval: false,
          getCoreRowModel: getCoreRowModel(),
          onSortingChange,
        },
      }}
      slotProps={{
        container: { ref: containerRef, onScroll },
      }}
      noDataMessage='No pending price approvals'
    />
  )
}
